import { plugin, debug, type ButtonProps } from 'light-component';
import { Button } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import type { IconNames } from 'zf-web-components/icons';
import type { CSSProperties, ReactElement } from 'react';

export function WidgetButton(props: ButtonProps): ReactElement {
  debug.widget('dashboard button', props);

  const style: CSSProperties = {
    backgroundColor: '#e44134',
    ...props.style
  };

  return (
    <div className={`${props.className ?? ''} draggable`}>
      <Button
        type='primary'
        style={style}
        icon={props.icon != null ? <Icons name={props.icon as IconNames} /> : null}
        onClick={props.onClick}
      >
        {t(props.title ?? '')}
      </Button>
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'button', component: WidgetButton });
